import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { GoogleOutlined, LogoutOutlined } from '@ant-design/icons'
import pkceChallenge from 'pkce-challenge'
import axios from 'axios'

const clientId = '613698822478-1r22ahfcp2u8mgh5jjt7t6ugdc52rjtu.apps.googleusercontent.com'
const redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI

function LoginGoogle() {
  const [cookies, setCookie, removeCookie] = useCookies(['id', 'token', 'cours_fav'])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const codeVerifier = sessionStorage.getItem('pkce_code_verifier')

    if (code && codeVerifier) {
      axios
        .post(`${process.env.REACT_APP_API_URL}google/auth`, {
          code,
          code_verifier: codeVerifier,
          redirect_uri: redirectUri,
        })
        .then((res) => {
          const { id, token, cours_fav } = res.data
          setCookie('id', id, { path: '/' })
          setCookie('token', token, { path: '/' })
          setCookie('cours_fav', cours_fav || '', { path: '/' })

          sessionStorage.removeItem('pkce_code_verifier')
          window.history.replaceState({}, document.title, window.location.pathname)
        })
        .catch((err) => {
          console.error('Erreur lors de la connexion Google:', err)
        })
    }
  }, [setCookie])

  const generateCodeVerifier = () => {
    const array = new Uint32Array(56)
    window.crypto.getRandomValues(array)
    return Array.from(array, (dec) => ('0' + dec.toString(16)).slice(-2)).join('')
  }

  const base64UrlEncode = (str) => {
    return btoa(String.fromCharCode(...new Uint8Array(str)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')
  }

  const generateCodeChallenge = async (verifier) => {
    const encoder = new TextEncoder()
    const data = encoder.encode(verifier)
    const digest = await window.crypto.subtle.digest('SHA-256', data)
    return base64UrlEncode(digest)
  }

  const handleLogin = async () => {
    const code_verifier = generateCodeVerifier()
    const code_challenge = await generateCodeChallenge(code_verifier)

    sessionStorage.setItem('pkce_code_verifier', code_verifier)

    const scopes = [
      'openid',
      'profile',
      'email',
      'https://www.googleapis.com/auth/drive.file',
      'https://www.googleapis.com/auth/calendar',
      'https://www.googleapis.com/auth/gmail.send',
    ].join(' ')

    const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth')
    authUrl.searchParams.set('client_id', clientId)
    authUrl.searchParams.set('redirect_uri', redirectUri)
    authUrl.searchParams.set('response_type', 'code')
    authUrl.searchParams.set('scope', scopes)
    authUrl.searchParams.set('code_challenge', code_challenge)
    authUrl.searchParams.set('code_challenge_method', 'S256')
    authUrl.searchParams.set('access_type', 'offline')
    authUrl.searchParams.set('prompt', 'consent')

    window.location.href = authUrl.toString()
  }

  const handleLogout = () => {
    removeCookie('id', { path: '/' })
    removeCookie('token', { path: '/' })
    removeCookie('cours_fav', { path: '/' })
  }

  return !cookies['id'] || !cookies['token'] ? (
    <li className="navbar-item flexbox-left" onClick={handleLogin}>
      <div className="navbar-item-inner flexbox-left">
        <div className="navbar-item-inner-icon-wrapper flexbox">
          <GoogleOutlined />
        </div>
        <span className="link-text">Login</span>
      </div>
    </li>
  ) : (
    <li className="navbar-item flexbox-left" onClick={handleLogout}>
      <div className="navbar-item-inner flexbox-left">
        <div className="navbar-item-inner-icon-wrapper flexbox">
          <LogoutOutlined />
        </div>
        <span className="link-text">Logout</span>
      </div>
    </li>
  )
}

export default LoginGoogle
